import { useTranslation } from 'react-i18next'
import { TbInfoCircleFilled, TbClockFilled } from 'react-icons/tb'

import './StatusLookupHeaderContent.scss'

export const StatusLookupHeaderContent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'statusLookupForm.headerContent',
  })
  return (
    <div className="header-content header-content--voter-registration">
      <ul className="header-content__icon-text-list">
        <li className="header-content__icon-text-list__item">
          <div className="header-content__icon-text-list__item__icon">
            <TbInfoCircleFilled color="white" />
          </div>
          <div className="header-content__icon-text-list__item__text">
            {t('first')}
          </div>
        </li>
        <li className="header-content__icon-text-list__item">
          <div className="header-content__icon-text-list__item__icon">
            <TbClockFilled color="white" />
          </div>
          <div className="header-content__icon-text-list__item__text">
            {t('second')}
          </div>
        </li>
      </ul>
    </div>
  )
}
